import React, { useState, useEffect } from 'react';
import { FormControl, TextField, Grid, Box, MenuItem, LinearProgress, Typography, InputLabel, Button } from '@mui/material/';

import axios from 'axios';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DataGrid, GridToolbar, frFR } from '@mui/x-data-grid';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Autorize from '../../components/ui/autorize';
import Cookies from 'js-cookie'
import DialogYesNo from '../../components/lib/dialog_yes_no';
import moment from "moment";

//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
export default function ProchaineFactureTrimestre() {
    const today = moment().format("YYYY-MM-DD");
    const [clublist, setList] = useState([]);

    const [autorize, setAutorize] = useState("false");
    const [datefacturation, setDatefacturation] = useState(today);
    const [trimestre, setTrimestre] = useState(getCustomQuarter(today));
    const [errorAxios, setErrorAxios] = useState("false");


    const MyAxios = axios.create({
        headers: {
            Authorization: "Bearer " + Cookies.get('token'),
        }
    })



    useEffect(() => {





        if (autorize) {
            //, { headers: { Authorization: "Bearer "+ cookies }}
            refreshData();
        }


    }, [datefacturation]);


  


    const refreshData = () => { // the callback. Use a better name      
        MyAxios.get(process.env.REACT_APP_API + '/rapports/get/getReport_POUR_FAIRE_FACTURATION_TRIMESTRIEL_ANNUEL/all/' + datefacturation) //axios.defaults.withCredentials = true
                .then((res) => {
                    setErrorAxios(false);
                    console.log(res);
                    setList(res.data);

                })
                .catch((error) => {
                    console.log(error)
                    setErrorAxios(true);

                });
    };



    const callbackAutoriser = (index) => { // the callback. Use a better name      
        setAutorize(index);
    };


    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }


    function setDateFacturation(MYValue) {
        setDatefacturation(MYValue);
        setTrimestre(getCustomQuarter(MYValue));
    }

    function getCustomQuarter(mydate_) {
        // Obtenir le mois de la date (1 pour Janvier, 12 pour Décembre)
        var mydate = moment(mydate_, "YYYY-MM-DD");
        //const mydate = new Date("2025-01-01");
        const month = mydate.month() + 1;
        console.log("getCustomQuarter date:" + mydate + " month: " + month);
        //const month = mydate.month() + 1;  

        // Vérifier si le mois est entre Octobre (10) et Décembre (12)
        if (month >= 10) {
            return 1; // Trimestre 1 (Oct-Dec)
        }
        // Vérifier si le mois est entre Janvier (1) et Mars (3)
        else if (month <= 3) {
            return 2; // Trimestre 2 (Jan-Mar)
        }
        // Vérifier si le mois est entre Avril (4) et Juin (6)
        else if (month >= 4 && month <= 6) {
            return 3; // Trimestre 3 (Apr-Jun)
        }
        // Sinon, le mois est entre Juillet (7) et Septembre (9)
        else {
            return 4; // Trimestre 4 (Jul-Sep)
        }
    }



    const columns = [
        { field: 'id', headerName: 'ID', width: 90 },
        { field: 'NoClub', headerName: 'Numéro de club', width: 150 },
        { field: 'clublegalname', headerName: 'Nom légal', width: 400 },
        { field: 'totalmembreactif', headerName: 'Total membre actif', width: 120 },
        { field: 'membreregulier', headerName: 'Membre regulier', width: 125 },
        { field: 'membreavie', headerName: 'Membre à vie', width: 100 },
        { field: 'membrecollegial', headerName: 'Membre collegial', width: 120 },
        { field: 'E_Mail_Address', headerName: 'Courriel', width: 300 },
        { field: 'first_name', headerName: 'Prénom', width: 110 },
        { field: 'last_name', headerName: 'Nom famille', width: 120 },
        { field: 'address', headerName: 'Addresse', width: 350 },
        { field: 'city', headerName: 'Ville', width: 300 },
        { field: 'postal_code', headerName: 'Code postal', width: 120 },
        { field: 'coupon_code', headerName: 'Coupon', width: 200 },
        { field: 'annual_payement', headerName: 'Paiement Annuel', width: 200, renderCell: (params) => { return params.value === 1 ? 'Oui' : 'Non'; }, },

    ];


    const rows = Array.isArray(clublist) ? clublist.map((item, index) => ({ id: index + 1, ...item })) : [];




    return (
        <div>
            <Autorize axiosError={errorAxios} callBackAutoriser={callbackAutoriser} />
            <form>
                <Typography variant='h6' ml={4} sx={{ fontSize: 17 }}>Les clubs de la prochaine facturation trimestrielle</Typography>

                <Grid item xs={12} >
                    <Box sx={{ display: 'flex', flexDirection: 'row', border: '1px solid grey', p: 2, m: 2, borderRadius: 2 }} >

                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='fr'>

                            <DatePicker
                                id="MyYear"
                                label="Date début"
                                key="dateDebut"
                                name="Effective_Date"
                                inputFormat="YYYY-MM-DD"
                                value={datefacturation}
                                onChange={(newValue) => setDateFacturation(formatDate(newValue))}
                                renderInput={(params) => <TextField {...params} />}
                            />



                        </LocalizationProvider>
                        <Typography variant='h6' ml={4} sx={{ fontSize: 17 }}>Cela représente la facturation du {trimestre} trimestre</Typography>
                    </Box>
                    
                </Grid>


                <Grid container direction="row" spacing={2} m={2} >


                    <Grid item container direction="row" >
                        <div style={{ height: '1000px', width: '90%' }}>

                            <DataGrid localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
                                rows={rows}

                                columns={columns}
                                pageSize={100}
                                rowsPerPageOptions={[100]}
                                components={{ Toolbar: GridToolbar }}
                            />
                        </div>
                    </Grid>

                </Grid>


            </form>

        </div>
    );

}


/*
 old facturation box.
  <Box sx={{ borderRadius: 3,padding:1,margin:1}}  style={{ border: "1px solid grey" }}>
                            
                                <Typography variant="h6" gutterBottom>Facturation</Typography>                                              
                                <InvoiceBilling key="invoicebill"  clubid={clubid} secteur={secteur}  />
                                
   </Box>

*/